export default {
  data() {
    return {
      now: new Date(),
      intervalId: null
    };
  },
  mounted() {
    this.intervalId = setInterval(() => {
      this.now = new Date();
    }, 250);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  }
};
